const Settings = () => {
  return (
    <svg
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99828 2.87547C1.28428 2.87547 0.738281 2.28747 0.738281 1.61547C0.738281 0.922468 1.30528 0.355469 1.99828 0.355469C2.69128 0.355469 3.25828 0.901468 3.25828 1.61547C3.25828 2.30847 2.69128 2.87547 1.99828 2.87547ZM1.99828 9.30147C1.28428 9.30147 0.738281 8.71347 0.738281 8.04147C0.738281 7.34847 1.30528 6.78147 1.99828 6.78147C2.64928 6.78147 3.25828 7.30647 3.25828 8.04147C3.25828 8.73447 2.69128 9.30147 1.99828 9.30147ZM1.99828 15.6435C1.28428 15.6435 0.738281 15.0555 0.738281 14.3835C0.738281 13.7325 1.26328 13.1235 1.99828 13.1235C2.69128 13.1235 3.25828 13.6905 3.25828 14.3835C3.25828 15.0975 2.69128 15.6435 1.99828 15.6435Z"
        fill="#1A1919"
      />
    </svg>
  );
};

export default Settings;
